import type { QueryKey } from "@tanstack/react-query";
import type { ErrorStatuses } from "web_myplann/Infrastructure/Api/Api";
import { ApiCallError } from "web_myplann/Infrastructure/Api/ApiUtils";
import {
	type AuthorizationCredentials,
	createAuthorizationHeaders,
} from "web_myplann/Shared/Utils/createAuthorizationHeaders";

type Args = {
	url: string;
	credentials: AuthorizationCredentials;
	errorMessage: string;
	skipToast?: boolean;
	queryKey?: QueryKey;
};

export const fetchAuthorized = async ({
	url,
	credentials,
	errorMessage,
	skipToast,
	queryKey,
}: Args): Promise<Response> => {
	const options: RequestInit = {
		headers: createAuthorizationHeaders(credentials),
	};

	const response = await fetch(url, options).catch(() => null);

	if (!response?.ok) {
		throw new ApiCallError(
			errorMessage,
			{
				data: null,
				error: new Error(response?.statusText ?? "Network error"),
				status: (response?.status ?? 0) as ErrorStatuses,
				args: { url, options },
			},
			skipToast ? { skipToastFor: true } : undefined,
			queryKey,
		);
	}

	return response;
};
